/* Casa Manavay · landing simple en 6 bloques, modelo v-gummies.com/products/hair (18 oct 2026)
   Pedido de Nicolás: más simple, información clara, flechitas arriba que bajan a cada sección.
   Orden fijo, igual para todos los productos:
   1 Recuadro de compra + mini descripción (metacampo custom.mini_descripcion) + 5 beneficios + flechitas
   2 ¿Qué hace?  = Beneficios + Comparativa + Qué trae, en una sola sección
   3 Antes y después (+ botón)
   4 Así se toma
   5 Preguntas, con la ficha y el aviso adentro como pregunta cerrada
   6 Pruébalo sin riesgo (+ botón)
   Se QUITAN: ¿Te pasa esto?, Envío y pago, ¿Es para ti?, packs dentro de la landing, sección "¿Dúo o triple?" y el cierre final.
   No se borra contenido de las plantillas: el script solo ordena y oculta, así se puede volver atrás. */
(function(){
  if(window.cmExtraOk) return; window.cmExtraOk = true;
  var QUITAR = ['identifica','pedido','para_quien','packs','cierre'];
  var GRUPO = ['beneficios','comparativa','formas'];
  function caja(){ return document.querySelector('.cm-buy') || document.querySelector('.product-form__buttons') || document.querySelector('product-form'); }
  function irA(el, extra){ if(!el) return; var y = el.getBoundingClientRect().top + window.pageYOffset - (extra || 90); window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' }); }
  function subir(){ irA(caja(), 110); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  /* Mini descripción bajo el título */
  function mini(){
    var txt = window.cmMini; if(!txt || typeof txt !== 'string') return;
    var t = document.querySelector('.product__info-container .product__title'); if(!t || document.querySelector('.cmx-mini')) return;
    var p = document.createElement('p'); p.className = 'cmx-mini'; p.textContent = txt;
    t.parentNode.insertBefore(p, t.nextSibling);
  }

  /* 5 beneficios junto al botón de compra */
  function beneficios(){
    var txt = window.cmBen; if(!txt || typeof txt !== 'string') return;
    var info = document.querySelector('.product__info-container'); if(!info || info.querySelector('.cmx-ben')) return;
    var form = info.querySelector('product-form, .product-form'); if(!form) return;
    var ul = document.createElement('ul'); ul.className = 'cmx-ben';
    txt.split(/\n/).forEach(function(l){
      l = l.trim(); if(!l) return;
      var p = l.split('|'); var li = document.createElement('li');
      var ic = document.createElement('i'); ic.setAttribute('aria-hidden','true'); ic.textContent = p.length > 1 ? p[0] : '✓';
      var sp = document.createElement('span'); sp.textContent = p.length > 1 ? p.slice(1).join('|') : p[0];
      li.appendChild(ic); li.appendChild(sp); ul.appendChild(li);
    });
    var bloque = form.closest('.product__info-container > *') || form;
    bloque.parentNode.insertBefore(ul, bloque);
    [].slice.call(info.querySelectorAll('div[style*="flex-wrap"]')).forEach(function(d){ if(d.querySelector('span b') && !d.closest('.cm-buy')){ d.style.display = 'none'; } });
  }

  function tipo(m){
    if(m.classList.contains('cmx-grupo')) return 'grupo';
    if(m.classList.contains('cmx-comp')) return 'comparativa';
    if(m.classList.contains('cmx-gar')) return 'garantia';
    if(m.querySelector('.lp-id')) return 'identifica';
    if(m.querySelector('.lp-ben')) return 'beneficios';
    if(m.querySelector('.lp-tr')) return 'transformacion';
    if(m.id === 'lp-formula') return 'formas';
    if(m.id === 'lp-packs') return 'packs';
    if(m.querySelector('.lp-pq')) return 'para_quien';
    if(m.querySelector('.lp-faq')) return 'preguntas';
    if(m.querySelector('.lp-fi')) return 'ficha';
    if(m.querySelector('.lp-ci')) return 'cierre';
    if(m.querySelector('.lp-steps')) return /env[ií]o y pago/i.test(m.textContent) ? 'pedido' : 'rutina';
    return null;
  }

  function comparativa(lp){
    if(document.querySelector('.cmx-comp')) return;
    var lineas = (typeof window.cmComp === 'string' ? window.cmComp : '').split(/\n/).map(function(x){ return x.trim(); }).filter(Boolean);
    var titulo = lineas[0] || '¿Qué hace especial a Casa Manavay?';
    var texto = lineas[1] || 'Lo pides, te lo confirmamos por WhatsApp y lo recibes en 3 a 5 días hábiles.';
    var filas = lineas.length > 2 ? lineas.slice(2) : ['Envío gratis a todo Chile', 'Confirmación por WhatsApp', 'Garantía de 30 días', 'Sellado de fábrica'];
    var h = '<div class="lp__wrap"><div class="cmx-grid">'
      + '<div class="cmx-txt"><span class="lp__eyebrow">Compara</span><h2 class="lp__h2">' + esc(titulo) + '</h2>'
      + '<p>' + esc(texto) + '</p>'
      + '<div class="cmx-cta"><button type="button" class="lp-btn" data-cmx-comprar>Lo quiero</button></div></div>'
      + '<div class="cmx-tab"><div class="cmx-cab"><span></span><span class="cmx-m">Casa Manavay</span><span>Otros</span></div><div class="cmx-cuerpo">';
    filas.forEach(function(f){ h += '<div class="cmx-fila"><strong>' + esc(f) + '</strong><b aria-label="Sí">✓</b><em aria-label="No">✕</em></div>'; });
    h += '</div></div></div></div>';
    var m = document.createElement('div'); m.className = 'lp__mod cmx-comp'; m.innerHTML = h;
    lp.appendChild(m);
  }

  function garantia(lp){
    if(document.querySelector('.cmx-gar')) return;
    var it = [
      ['M1 3h15v13H1z M16 8h4l3 3v5h-7V8z', 'Envío gratis', 'De Arica a Punta Arenas, en 3 a 5 días hábiles.'],
      ['M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z M9 12l2 2 4-4', 'Garantía de 30 días', 'Si llega roto, incompleto o distinto, te lo cambiamos sin costo.'],
      ['M21 8l-9-5-9 5 9 5 9-5z M3 8v8l9 5 9-5V8 M12 13v8', 'Sellado de fábrica', 'Cada frasco llega con su sello de seguridad. Revísalo al recibir.']
    ];
    var h = '<div class="lp__wrap"><div class="lp__hd"><span class="lp__eyebrow">Sin riesgo</span><h2 class="lp__h2">Pruébalo sin riesgo</h2></div><div class="cmx-gar__g">';
    it.forEach(function(x){ h += '<div class="cmx-gar__i"><span class="cmx-gar__ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="' + x[0] + '"/></svg></span><b>' + x[1] + '</b><span>' + x[2] + '</span></div>'; });
    h += '</div><div class="cmx-cta"><button type="button" class="lp-btn" data-cmx-comprar>Pedir ahora</button><small>Pagas al recibir · Envío gratis</small></div></div>';
    var m = document.createElement('div'); m.className = 'lp__mod cmx-gar'; m.innerHTML = h;
    lp.appendChild(m);
  }

  function cta(mod){
    var w = mod.querySelector('.lp__wrap'); if(!w || w.querySelector('.cmx-cta')) return;
    var d = document.createElement('div'); d.className = 'cmx-cta';
    d.innerHTML = '<button type="button" class="lp-btn" data-cmx-comprar>Lo quiero</button><small>Envío gratis · Llega en 3 a 5 días hábiles</small>';    w.appendChild(d);
  }

  /* Ficha y aviso pasan a ser una pregunta cerrada dentro de Preguntas */
  function fichaEnPreguntas(base){
    var fi = null, pr = null;
    [].slice.call(base.children).forEach(function(h){ var t = tipo(h); if(t === 'ficha') fi = h; if(t === 'preguntas') pr = h; });
    if(!fi || !pr) return;
    var faq = pr.querySelector('.lp-faq'); var grid = fi.querySelector('.lp-fi-grid');
    if(!faq || !grid) return;
    var d = document.createElement('details'); d.className = 'lp__card cmx-fi';
    d.innerHTML = '<summary><span>Ficha del producto y aviso</span><i aria-hidden="true">+</i></summary><div class="lp-faq__a"></div>';
    grid.classList.add('is-in');
    d.querySelector('.lp-faq__a').appendChild(grid);
    faq.appendChild(d);
    base.removeChild(fi);
  }

  /* Así se toma: 4 pasos desde el metacampo custom.rutina (una línea por paso: Etiqueta | Título | Texto). El último va en lima. */
  function rutina(mod){
    var txt = window.cmRutina; if(!txt || typeof txt !== 'string') return;
    var lineas = txt.split(/\n/).map(function(x){ return x.trim(); }).filter(Boolean);
    var cont = mod.querySelector('.lp-steps'); if(!cont || !lineas.length) return;
    var items = [].slice.call(cont.querySelectorAll('.lp-steps__item'));
    lineas.forEach(function(l, i){
      var p = l.split('|').map(function(x){ return x.trim(); });
      var it = items[i];
      if(!it){ it = document.createElement('div'); it.className = 'lp-steps__item lp__card is-in'; it.innerHTML = '<span class="lp-steps__tag"></span><h3 class="lp__h3"></h3><p class="lp__p"></p>'; cont.appendChild(it); items.push(it); }
      it.querySelector('.lp-steps__tag').textContent = p[0] || '';
      it.querySelector('.lp__h3').textContent = p[1] || '';
      it.querySelector('.lp__p').textContent = p.slice(2).join(' | ');
    });
    items.forEach(function(it, i){
      if(i >= lineas.length){ it.parentNode.removeChild(it); return; }
      it.classList.toggle('lp-steps__item--lima', i === lineas.length - 1);
    });
  }

  /* Botón "Volver a Pedir ahora" al final de las secciones a las que llevan las flechitas */
  var FLECHA_ARRIBA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
  function volver(mod){
    if(!mod || mod.querySelector('.cmx-volver')) return;
    var d = document.createElement('div'); d.className = 'cmx-volver';
    d.innerHTML = '<button type="button" data-cmx-comprar>' + FLECHA_ARRIBA + 'Volver a Pedir ahora</button>';
    var w = mod.classList.contains('cmx-grupo') ? mod : (mod.querySelector('.lp__wrap') || mod);
    w.appendChild(d);
  }

  /* Beneficios + Comparativa + Qué trae en una sola sección */
  function agrupar(base){
    var piezas = [];
    GRUPO.forEach(function(g){ [].slice.call(base.children).forEach(function(h){ if(tipo(h) === g) piezas.push(h); }); });
    if(!piezas.length) return;
    var gr = document.createElement('div'); gr.className = 'lp__mod cmx-grupo';
    base.insertBefore(gr, piezas[0]);
    piezas.forEach(function(p){ p.classList.remove('lp__mod--alt'); gr.appendChild(p); });
    var ey = gr.querySelector('.lp__eyebrow'); if(ey){ ey.textContent = '¿Qué hace?'; }
  }

  function ordenar(){
    var lps = [].slice.call(document.querySelectorAll('.lp'));
    if(!lps.length) return;
    var base = lps[0];
    /* Juntar todo en una sola landing (algunos productos vienen en dos partes) */
    lps.slice(1).forEach(function(lp){
      [].slice.call(lp.children).forEach(function(h){ base.appendChild(h); });
      var sec = lp.closest('.shopify-section'); if(sec){ sec.style.display = 'none'; }
    });
    /* Sección "¿Dúo o triple?" fuera de la landing */
    [].slice.call(document.querySelectorAll('#MainContent .cpk')).forEach(function(c){ var s = c.closest('.shopify-section'); if(s){ s.style.display = 'none'; } });
    /* Quitar lo que sobra */
    [].slice.call(base.children).forEach(function(h){
      var t = tipo(h);
      if(QUITAR.indexOf(t) > -1 || h.classList.contains('lp-cinta')){ base.removeChild(h); }
    });
    comparativa(base);
    garantia(base);
    fichaEnPreguntas(base);
    agrupar(base);
    var ORDEN = ['grupo','transformacion','rutina','preguntas','ficha','garantia'];
    var IDS = { grupo: 'cmx-hace', transformacion: 'cmx-res', rutina: 'cmx-toma', preguntas: 'cmx-faq' };
    var conocidos = [].slice.call(base.children).filter(function(h){ return ORDEN.indexOf(tipo(h)) > -1; });
    conocidos.sort(function(a, b){ return ORDEN.indexOf(tipo(a)) - ORDEN.indexOf(tipo(b)); });
    conocidos.forEach(function(h, i){
      base.appendChild(h);
      var t = tipo(h);
      if(IDS[t] && !document.getElementById(IDS[t])){ h.id = IDS[t]; }
      h.classList.toggle('lp__mod--alt', i % 2 === 0);
      if(t === 'rutina'){ rutina(h); }
      if(t === 'grupo' || t === 'transformacion' || t === 'rutina' || t === 'preguntas'){ volver(h); }
    });
    document.querySelectorAll('[data-cmx-comprar]').forEach(function(b){ b.addEventListener('click', subir); });
  }

  /* Flechitas bajo el recuadro de compra */
  var nF = 0;
  function flechas(){
    if(document.querySelector('.cmx-ir')) return;
    var buy = document.querySelector('.cm-buy');
    var info = buy && buy.querySelector('.cm-info');
    if(!info && nF++ < 60){ setTimeout(flechas, 250); return; }
    if(!buy){ buy = caja(); }
    if(!buy) return;
    /* El recuadro de ruta de envío repite lo que ya dicen los íconos y "Pruébalo sin riesgo" */
    var ruta = buy.querySelector('.cm-ruta'); if(ruta){ ruta.style.display = 'none'; }
    var ops = [['cmx-hace','¿Qué hace?'],['cmx-res','Antes y después'],['cmx-toma','Cómo se toma'],['cmx-faq','Preguntas']];
    var nav = document.createElement('nav'); nav.className = 'cmx-ir'; nav.setAttribute('aria-label','Ir a una sección');
    ops.forEach(function(o){
      if(!document.getElementById(o[0])) return;
      var b = document.createElement('button'); b.type = 'button';
      b.innerHTML = esc(o[1]) + ' <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M6 13l6 6 6-6"/></svg>';
      b.addEventListener('click', function(){ irA(document.getElementById(o[0]), 80); });
      nav.appendChild(b);
    });
    if(!nav.children.length) return;
    if(info){ info.parentNode.insertBefore(nav, info); } else { buy.parentNode.insertBefore(nav, buy.nextSibling); }
  }

  function iniciar(){ mini(); beneficios(); ordenar(); flechas(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', iniciar); } else { iniciar(); }
})();
